import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadOnceService {

  loadStates: { [id: string]: LoadState } = {};

  async loadOnce(id, loadFn: () => Promise<any>, loading$?: Observable<boolean>, loaded$?: Observable<boolean>, failed$?: Observable<boolean>): Promise<void> {
    let loadState = this.getOrCreateLoadState(id, loading$, loaded$, failed$);
    if (await loadState?.isLoading() || await loadState?.isLoaded() || await loadState?.isFailed()) {
      return;
    }
    loadState.loading = true;
    try {
      await loadFn();
      loadState.loaded = true;
    } catch (error) {
      loadState.failed = true;
      loadState.errorMessage = error?.toString();
    } finally {
      loadState.loading = false;
    }

  }

  private getOrCreateLoadState(id: string, loading$?: Observable<boolean>, loaded$?: Observable<boolean>, failed$?: Observable<boolean>): LoadState {
    let loadState = this.loadStates[id];
    if (!loadState) {
      loadState = new LoadState();
      this.loadStates[id] = loadState;
    }
    loadState.loaded$ = loaded$ || loadState.loaded$;
    loadState.loading$ = loading$ || loadState.loading$;
    loadState.failed$ = failed$ || loadState.failed$;
    return loadState;
  }
}


class LoadState {
  loading?: boolean;
  loaded?: boolean;
  failed?: boolean;
  loading$?: Observable<boolean>;
  loaded$?: Observable<boolean>;
  failed$?: Observable<boolean>;
  errorMessage?: string;

  async isLoading(): Promise<boolean> {
    if (this.loading$) {
      this.loading = await firstValueFrom(this.loading$);
    }
    return this.loading;
  }

  async isLoaded(): Promise<boolean> {
    if (this.loaded$) {
      this.loaded = await firstValueFrom(this.loaded$);
    }
    return this.loaded;
  }

  async isFailed(): Promise<boolean> {
    if (this.failed$) {
      this.failed = await firstValueFrom(this.failed$);
    }
    return this.failed;
  }
}
